module.exports = __webpack_public_path__ + "img/Main_rightArrow.a2c0c8e5.png";